import { NavLink } from "react-router-dom";

export const ClientSidebar = (
  <>
    <NavLink to="/cuenta" end data-testid="nav-dashboard"><i className="fas fa-th-large" /> Dashboard</NavLink>
    <NavLink to="/cuenta/beneficiarios" data-testid="nav-beneficiarios"><i className="fas fa-users" /> Beneficiarios</NavLink>
    <NavLink to="/cuenta/solicitar" data-testid="nav-solicitar"><i className="fas fa-bell" /> Solicitar servicio</NavLink>
    <NavLink to="/cuenta/historial" data-testid="nav-historial"><i className="fas fa-history" /> Historial</NavLink>
    <NavLink to="/cuenta/salud" data-testid="nav-salud"><i className="fas fa-heart-pulse" /> Chequeo de salud</NavLink>
    <NavLink to="/cuenta/plan" data-testid="nav-plan"><i className="fas fa-credit-card" /> Mi plan</NavLink>
    <NavLink to="/cuenta/referidos" data-testid="nav-referidos"><i className="fas fa-gift" /> Referidos</NavLink>
  </>
);

export const AdminSidebar = (
  <>
    <NavLink to="/admin" end data-testid="nav-admin-dashboard"><i className="fas fa-chart-line" /> Dashboard</NavLink>
    <NavLink to="/admin/miembros" data-testid="nav-admin-miembros"><i className="fas fa-users" /> Miembros</NavLink>
    <NavLink to="/admin/solicitudes" data-testid="nav-admin-solicitudes"><i className="fas fa-headset" /> Solicitudes</NavLink>
    <NavLink to="/admin/whatsapp" data-testid="nav-admin-whatsapp"><i className="fab fa-whatsapp" /> Bot WhatsApp</NavLink>
    <NavLink to="/admin/security" data-testid="nav-admin-security"><i className="fas fa-shield-alt" /> Seguridad</NavLink>
    <NavLink to="/admin/audit" data-testid="nav-admin-audit"><i className="fas fa-clipboard-list" /> Auditoría</NavLink>
  </>
);
